var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    {
      staticClass: "library-card",
      on: {
        mouseover: function($event) {
          return _vm.handleCardOver(_vm.card.id)
        },
        mouseleave: _vm.handleCardLeave
      }
    },
    [
      _vm.selectedCardId === _vm.card.id
        ? _c("div", { staticClass: "card-background" }, [
            _c("div", { staticClass: "card-action-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.openCardPreview }
                },
                [
                  _c("div", { staticClass: "icon-label" }, [
                    _c("img", {
                      attrs: { src: "/static/images/ic-eye.svg", alt: "icon" }
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.preview")) +
                        "\n        "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "card-action-button",
                  attrs: { type: "button" },
                  on: { click: _vm.goToCardDetails }
                },
                [
                  _c("div", { staticClass: "icon-label" }, [
                    _c("img", {
                      attrs: {
                        src: "/static/images/ic-zoom-in.svg",
                        alt: "icon"
                      }
                    }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("common.detail_view")) +
                        "\n        "
                    )
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-cover-img-thumb clickable",
          style: _vm.styleBindings
        },
        [
          false
            ? _c("div", { staticClass: "card-action" }, [
                _c(
                  "div",
                  { staticClass: "card-action-btn" },
                  [
                    _c(
                      "IconDropdown",
                      { attrs: { dropup: false } },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "dropdown-item",
                            on: { click: _vm.openCardPreview }
                          },
                          [_vm._v(_vm._s(_vm.$t("common.preview")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-block clickable" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 card-info-section" }, [
            _c("div", { staticClass: "card-body" }, [
              _c(
                "h4",
                {
                  staticClass: "card-title",
                  class: _vm.card.title.length > 20 && "long-title",
                  attrs: { title: _vm.card.title }
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.card.title) + "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "card-subtitle typography--caption" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.getGradeLabel(_vm.card)) +
                    " ∙\n            " +
                    _vm._s(_vm.getSubjectLabel(_vm.card)) +
                    "\n            "
                ),
                _vm.card.chapter_name
                  ? _c("span", [
                      _vm._v(
                        "\n              ∙ " +
                          _vm._s(_vm.card.chapter_name) +
                          "\n            "
                      )
                    ])
                  : _vm.card.core_concept_id
                  ? _c("span", [
                      _vm._v(
                        "\n              ∙ " +
                          _vm._s(
                            _vm.getCoreConceptLabel(_vm.card.core_concept)
                          ) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "card-bottom-desc" }, [
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _vm.card.page_count - _vm.card.quiz_count > 0
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.card.non_quiz")) +
                              " " +
                              _vm._s(
                                _vm.$t("common.card.count", {
                                  cnt: _vm.card.page_count - _vm.card.quiz_count
                                })
                              ) +
                              "\n              "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.page_count - _vm.card.quiz_count > 0 &&
                    _vm.card.quiz_count > 0
                      ? _c("span", [_vm._v("∙")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.quiz_count > 0
                      ? _c("span", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.card.quiz")) +
                              " " +
                              _vm._s(
                                _vm.$t("common.card.count", {
                                  cnt: _vm.card.quiz_count
                                })
                              ) +
                              "\n              "
                          )
                        ])
                      : _c("span", { staticStyle: { color: "transparent" } }, [
                          _vm._v("_")
                        ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "small",
                  {
                    staticClass:
                      "typography--caption typography--color-secondary"
                  },
                  [
                    _c("strong", [_vm._v(_vm._s(_vm.card.author_name))]),
                    _vm._v(" "),
                    _vm.card.assigned_count
                      ? _c("span", [
                          _vm._v(
                            "| " +
                              _vm._s(
                                _vm.$t("common.card.share_count", {
                                  cnt: _vm.card.assigned_count
                                })
                              )
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              !_vm.card.publisher_id
                ? _c("div", [
                    _c(
                      "small",
                      {
                        staticClass:
                          "typography--caption typography--color-secondary"
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.card.updated_at")) +
                            ": " +
                            _vm._s(_vm._f("datetime")(_vm.card.updated_at)) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d975b426", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d975b426","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/library/components/LibraryCard.vue
// module id = Q3Ac
// module chunks = 1